import { timeMonth, timeYear } from 'd3-time';
import dayjs from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';

dayjs.extend(weekOfYear);

const xAxisTickFormatYear = (v) => dayjs(v).format('YYYY');

const defaultXAxisTickFns = {
    xAxisTickFormat: xAxisTickFormatYear,
    xAxisTickValues: timeYear,
};

export const getXAxisTickFns = (data) => {
    const tsLen = data?.[0]?.timeSeries?.length;
    if (!tsLen) return defaultXAxisTickFns;
    if (tsLen < 6)
        return {
            xAxisTickFormat: (v) => dayjs(v).format('MMM'),
            xAxisTickValues: timeMonth.every(1),
        };
    if (tsLen < 12)
        return {
            xAxisTickFormat: (v) => dayjs(v).format('MMM'),
            xAxisTickValues: timeMonth.every(2),
        };
    return defaultXAxisTickFns;
};
